module.exports = __webpack_public_path__ + "img/en.01e9a9e5.svg";